import React, {  useState } from "react";
import "./Login.scss";
import FormInputs from "../../components/FormInputs/FormInputs";
import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { UserLogin } from "../../utils/apiCalls";
import Loader from "../../components/Loader";
import ReusableModal from "../../components/ReusableModal/ReusableModal";
import { Typography } from "antd";
import loginImage from "../../assets/Images/LoginImage.png";
import { jwtDecode } from "jwt-decode";
import { useToken } from "../../store/useToken";

const initialValues = {
  username: "",
  password: "",
};

const Login = () => {
  const { setDecodedToken } = useToken();
  const [login, setLogin] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [messages, setMessages] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate("/signup");
  };

  const handleNavigate = () => {
    navigate("/forgotpassword");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateFields = () => {
    let errObj = { ...initialValues };
    if (!login.username) {
      errObj.username = "Username is required";
    }  else {
      errObj.username = "";
    }
    if (!login.password.trim()) {
      errObj.password = "Password is required";
    } else {
      errObj.password = "";
    }
    setErrors(errObj);
    const data = Object.values(errObj).every((x) => x === "" || x === null);
    return data;
  };

  const handleLogin = () => {
    setIsLoading(true);
    if (validateFields()) {
      const payload = {
        username: login.username,
        password: login.password,
      };
      UserLogin((res) => {
        const { statusCode, data, message } = res;
        if (statusCode === 200) {
          localStorage.setItem("accessToken", data.accessToken);
          const decodedToken = jwtDecode(data.accessToken);
          localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
          setDecodedToken(decodedToken);
          setIsLoading(false);
          navigate("/learnermanagement");
        } else {
          setOpenModal(true);
          setMessages(message);
          setIsLoading(false);
          navigate("/");
        }
      }, payload);
    } else {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
      <div className="login">
        <div className="login_container">
          <div className="login_section">
            <div className="login_section_left">
              <div className="login_section_left_img">
                <img src={loginImage} alt="LoginImage" />
              </div>
            </div>
            <div className="login_section_right">
              <div className="login_section_right_box">
                <div className="login_section_right_box_header">
                  <div className="login_section_right_box_header_heading">
                    <h1>Login</h1>
                  </div>
                  <div
                    className="login_section_right_box_header_text"
                    onClick={handleSignUp}
                  >
                    <p>
                      Don't have an account? <span>Create </span>
                    </p>
                  </div>
                  <div className="login_section_right_box_header_content">
                    <div className="login_section_right_box_header_content_inputs">
                      <FormInputs
                        title="Username"
                        type="text"
                        placeholder="Enter your username"
                        name="username"
                        value={login.username}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        error={errors.username}
                      />
                    </div>
                    <div className="login_section_right_box_header_content_inputs">
                      <FormInputs
                        title="Password"
                        type="password"
                        placeholder="Enter your password"
                        name="password"
                        value={login.password}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        error={errors.password}
                      />
                    </div>
                    <div
                      className="login_section_right_box_header_content_txt"
                      onClick={handleNavigate}
                    >
                      <span>Forgot Password?</span>
                    </div>
                    <div className="login_section_right_box_header_content_button">
                      <Button onClick={handleLogin}>Login</Button>
                    </div>
                    <div className="line"></div>
                    <div className="login_section_right_box_header_content_text">
                      <p>
                        Have some problems? Please{" "}
                        <span onClick={() => navigate("/logincontactsupport")}>
                          contact support.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="loader-container">
          <Loader />
        </div>
      )}
      {openModal && (
        <ReusableModal
          children={
            <Typography
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "15px",
              }}
            >
              {messages}
            </Typography>
          }
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onOk={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default Login;
